import { useState } from 'react'
import { useMarketingList } from '../../assets/api/useAdminApi';
import CustomPagination from '../../shared/utils/CustomPagination';
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import { Box, Tooltip, Typography } from '@mui/material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import useMarketingDetailStore from '../../store/useMarketingDetailStore';
import EditIcon from '@mui/icons-material/Edit';

const CommonMarketingTable = ({ marketingadRows,isLoading }) => {
    const { setMarketingDetail } = useMarketingDetailStore();

    const [payoutPaginationModel, setPayoutPaginationModel] = useState({ page: 0, pageSize: 5 });


    const MarketColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 0.5,
            renderCell: (params) => <Typography variant="body1">{params.value}</Typography>
        },
         {
            field: "apartment_name",
            headerName: "Apartment Name",
           width: 200,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "type_of_ads",
            headerName: "Type Of Ads",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "number_of_ads",
            headerName: "No. Of Ads",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "ads_amount",
            headerName: "Ads Amount",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        
        {
            field: "from_date",
            headerName: "From Date",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "to_date",
            headerName: "To Date",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "actions",
            type: "actions",
            headerName: "Actions",
            flex: 1,
            cellClassName: "actions",
            renderCell: (params) => (
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <Tooltip title="Edit">
                        <GridActionsCellItem
                            key={0}
                            icon={<EditIcon />}
                            label="Edit"
                            onClick={() => {
                                const selectedmarketing = marketingadRows?.find(row => row?.id === params?.id);
                                if (selectedmarketing) {
                                    setMarketingDetail(selectedmarketing)
                                }
                            }}
                        />
                    </Tooltip>
                </Box>
            ),
        }

    ];
    return (
        <>

            {isLoading? (
                <DataGridSkeleton rowsNum={5} />
            ) : (
                <DataGrid
                    rows={marketingadRows}
                    columns={MarketColumns}
                    pagination
                    paginationModel={payoutPaginationModel}
                    onPaginationModelChange={setPayoutPaginationModel}
                    pageSizeOptions={[5]}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={payoutPaginationModel}
                                setPaginationModel={setPayoutPaginationModel}
                                totalRows={marketingadRows?.length || 0}
                                pageSize={payoutPaginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )
            }
        </>
    )
}

export default CommonMarketingTable